/*
 *   File : create-lead.js
 *   Author : https://evoqins.com
 *   Description : Create lead modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { useEffect, useState } from 'react';

//Custom components
import { CustomSelectBox, CustomTextInput } from '../FormElements';
import { Icon } from '../Icon';
import { PrimaryButton, SecondaryButton } from '../Buttons';

//Style
import Color from "../../Style/color.scss";
import { toast } from 'react-toastify';
import { APIService } from '../../Service';

const DATA = [
    {
        id: 1,
        label: 'Sample 1',
        value: 'Sample 1',
    },
    {
        id: 2,
        label: 'Sample 2',
        value: 'Sample 2',
    },
    {
        id: 3,
        label: 'Sample',
        value: 'Sample 3'
    },
    {
        id: 4,
        label: 'Sample',
        value: 'Sample'
    }
];

const CreateLeadModal = (props) => {

    const [name, setName] = useState("");
    const [nameError, setNameError] = useState("");
    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState("");

    const [number, setNumber] = useState("");
    const [numberError, setNumberError] = useState("");
    const [selectedAssign, setSelectedAssign] = useState(null);
    const [selectedAssignError, setSelectedAssignError] = useState("");
    const [source, setSource] = useState("");
    const [sourceError, setSourceError] = useState("");
    const [buttonLoader, setButtonLoader] = useState(false);

    useEffect(() => {
        setNameError("");
    }, [name]);

    useEffect(() => {
        setEmailError("");
    }, [email]);

    useEffect(() => {
        setNumberError("");
    }, [number]);

    useEffect(() => {
        setSelectedAssignError("");
    }, [selectedAssign]);

    useEffect(() => {
        setSourceError("");
    }, [source]);

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("create-lead-modal-close");
        button.click();
        props.handleClose();
    };

    // handle success modal
    const _handleSuccess = () => {
        _handleCloseModal();
        props.handleSuccess();
    };

    // handle send email
    const _handleAddLead = () => {
        let is_valid = true;
        let validate_email = /^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/;
        let validate_number = /^[6-9]\d{9}$/;

        if (name.trim().length === 0) {
            setNameError("Please provide name");
            is_valid = false;
        }

        if (email.trim().length === 0) {
            setEmailError("Please provide email");
            is_valid = false;
        } else if (!validate_email.test(email)) {
            setEmailError("Please provide a valid email");
            is_valid = false;
        }

        if (number.trim().length === 0) {
            setNumberError("Please provide phone number");
            is_valid = false;
        } else if (!validate_number.test(number)) {
            setNumberError("Please provide a valid number");
            is_valid = false;
        }

        if (source.trim().length === 0) {
            setSourceError("Please provide source of lead");
            is_valid = false;
        }

        if (selectedAssign === null) {
            setSelectedAssignError("Please select assign");
            is_valid = false;
        }


        if (is_valid === true) {
            _createLead();
        }
    };

    // API - Lead stage data
    const _createLead = () => {
        let is_post = true;
        let url = 'lead/create-lead';
        let data = {
            "name": name,
            "email": email,
            "mobile": number,
            "source": source,
            "assigned_to": selectedAssign.value
        };

        setButtonLoader(true);
        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                _handleSuccess();
                toast.dismiss();
                toast.success("Successfully added", {
                    type: "success",
                    className: "e-toast",
                });
            } else {
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
            setButtonLoader(false);
        });
    };

    return (
        <div className="modal fade"
            id="create-lead-modal" data-bs-backdrop="static" data-bs-keyboard="false"
            tabIndex="-1" aria-labelledby="createLeadModalLabel" aria-hidden="true">
            <div className={`modal-lg modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-28`}>
                <span id='create-lead-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className=" modal-content border-radius-28 overflow-hidden border-0 e-bg-white-dark">

                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-between align-items-center padding-32px-lr padding-32px-top pb-4">
                        <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                            Add lead
                        </h6>
                        <Icon icon='close'
                            size="1.125rem"
                            className="d-flex cursor-pointer"
                            onClick={_handleCloseModal} />
                    </div>

                    {/* Modal body */}
                    <div className={`modal-body pt-0 padding-32px-lr padding-32px-bottom`}>

                        <div className='row pb-4'>
                            {/* Name */}
                            <div className='col-6'>
                                <CustomTextInput label="Name"
                                    placeholder="Enter name"
                                    type="text"
                                    autoFocus={true}
                                    required={true}
                                    value={name}
                                    error={nameError}
                                    className="w-100"
                                    inputType={2}
                                    onKeyPress={_handleAddLead}
                                    handleChange={(e) => setName(e)} />
                            </div>

                            {/* Email */}
                            <div className='col-6'>
                                <CustomTextInput label="Email"
                                    placeholder="Enter email"
                                    type="text"
                                    required={true}
                                    value={email}
                                    error={emailError}
                                    className="w-100"
                                    inputType={2}
                                    onKeyPress={_handleAddLead}
                                    handleChange={(e) => setEmail(e)} />
                            </div>
                        </div>

                        <div className='row pb-4'>
                            {/* Phone number */}
                            <div className='col-6'>
                                <CustomTextInput label="Phone number"
                                    placeholder="Enter phone number"
                                    type="number"
                                    required={true}
                                    value={number}
                                    error={numberError}
                                    className="w-100"
                                    inputType={2}
                                    onKeyPress={_handleAddLead}
                                    handleChange={(e) => {
                                        if (e.length <= 10) {
                                            setNumber(e);
                                        }
                                    }} />
                            </div>

                            {/* Source of the lead */}
                            <div className='col-6'>
                                <CustomTextInput label="Source of the lead"
                                    placeholder="Enter source"
                                    type="text"
                                    required={true}
                                    value={source}
                                    error={sourceError}
                                    className="w-100"
                                    inputType={2}
                                    onKeyPress={_handleAddLead}
                                    handleChange={(e) => setSource(e)} />

                            </div>
                        </div>

                        <div className='row pb-4'>
                            {/* Assign to */}
                            <div className='col-6'>
                                <CustomSelectBox title='Assign to'
                                    placeholder='Select Junior RM'
                                    controlWidth='w-100'
                                    required={true}
                                    options={props.adminList}
                                    isSearchable={true}
                                    loader={props.loader}
                                    borderColor={`0.031rem solid ${Color.arsenic}`}
                                    padding="0.5rem 1rem"
                                    value={selectedAssign}
                                    error={selectedAssignError}
                                    onChange={(data) => setSelectedAssign(data)} />
                            </div>
                        </div>

                        {/* Info .. */}
                        <div className='mt-2 e-bg-magnolia-light p-3 border-radius-8 d-flex gap-1 align-items-start'>
                            <Icon icon="info"
                                size="1rem"
                                color={Color.davys_grey_light}
                                className="d-flex" />

                            <p className='mb-0 e-text-davys-grey-light e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                                Once the lead is added,  user will receive notifications via email and SMS.
                            </p>
                        </div>
                    </div>

                    {/* Modal footer */}
                    <div className='modal-footer border-0 pt-0 padding-32px-lr padding-32px-bottom gap-4'>
                        <SecondaryButton name="Cancel"
                            className="py-3 padding-70px-lr"
                            onClick={_handleCloseModal} />
                        <PrimaryButton name="Add Lead"
                            className={`${buttonLoader ? "w-178px" : ""} padding-60px-lr py-3`}
                            loader={buttonLoader}
                            onClick={_handleAddLead} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreateLeadModal;

CreateLeadModal.defaultProps = {
    handleClose: () => { }
};